import React, {useState, useEffect} from 'react'
import back1 from "../../assets/images/back22.jpg"
import icon1 from "../../assets/jobIcons/icon1.svg"
// import datas from '../../datas/Datas.json'
import JobCard from '../../components/Cards/JobCard'
import Modal from "../../../components/Modal"
import ReactQuill from 'react-quill'
import "react-quill/dist/quill.snow.css"
import { CgClose } from 'react-icons/cg'
import axios from "axios"
import {useParams} from "react-router-dom"
import FilePicker from "../../../components/FilePicker"
import Input from '../../../components/Form/Input'
import TextAreaEditor from '../../../components/Form/TextAreaEditor'
import Select from '../../../components/Form/Select'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSingleJob } from '../../../redux/jobSlice'
import JobApplicationModal from '../../../components/Modal/JobApplicationModal'
import TestResume from "../TestResume"
import { JOB_API_END_POINT, END_POINT } from '../../../utils/constant'
import ImageWithFallback from '../../components/ImageWithFallback'
import FAQ from "../Home/partials/FAQSection"
import Confetti from "../../../components/Confetti"
import { FaBriefcase, FaClock, FaMoneyBillWave, FaCalendarAlt, FaRegCalendarTimes } from 'react-icons/fa';

const JobDetail = () => {
  // const [jobs, setJobs] = useState(datas)
  const [showModal, setShowModal] = useState(false)
  const [value, setValue] = useState("")
  const { id } = useParams(); // Récupérer l'id du job à partir de l'URL
  const dispatch = useDispatch();
  const [singleJob, setSingleJob] = useState({})
  const {user} = useSelector(store=>store.user)
  const [showConfetti, setshowConfetti] = useState(false)

  const fetchJobDetails = async () => {    
      const response = await axios.get(`${JOB_API_END_POINT}/${id}`)
      .then((response) => {setSingleJob(response.data) ; console.log(response.data)})
      .catch((error) => { console.error('Erreur lors de la récupération des détails du job:', error);})    
  }
 
  useEffect(() => {
    
    if (id) {
      fetchJobDetails()
    }
  }, [id]);
  // useEffect(() => {
  //   fetchJobDetails()
  //   if (id) {
  //     dispatch(fetchSingleJob(id));
  //     console.log("hello from useffect", singleJob)
  //   }
  // }, [dispatch, id]);

  // Placeholder pour des données mockées (supprimez-le si vous utilisez Redux)
  const [jobDetails, setJobDetails] = useState(singleJob || {});

  // useEffect(() => {
  //   if (singleJob) {
  //     setJobDetails(singleJob);
  //   }
  //   console.log("hello from useffect", singleJob)
  // }, [id]);
  
  useEffect(() => {
    console.log("Updated singleJob from Redux:", singleJob);
  }, [singleJob]);

  const handleSuccess = () => {
    showConfetti(true)
    alert("Votre candidature a été envoyée avec succès !");
    setTimeout(() => {
      showConfetti(false)
    }, 2000);
  };

  // Fonction pour formater les dates
const formatDateTime = (dateString) => {
  if (!dateString) return "Non spécifiée";
  const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', options).format(date);
};

// Fonction pour formater le salaire
const formatSalary = (salary) => {
  if (!salary) return "Non spécifié";
  return new Intl.NumberFormat('fr-FR', { useGrouping: true }).format(parseInt(salary, 10));
};
  
  return (
    <>
      <div className="bg-neutral-100 mb-6 rounded-lg h-56 mx-3 md:mx-6  lg:mx-20 mt-10 object-cover bg-top bg-center" style={{backgroundImage: "url("+END_POINT+"/storage/"+singleJob?.offer?.image+")", objectFit: "cover"}}>
        <div className="overflow-hidden absolute mb-6 mt-[140px] md:mt-[120px] ml-6 md:ml-10 lg:ml-20 bg-gray-50 border-2 rounded-md flex justify-center items-center w-20 md:w-28 h-16 md:h-20 shadow">

           <ImageWithFallback src={END_POINT+ "/storage"+singleJob?.offer?.user?.organisation_profile?.logo} className="  object-cover" defaultType="logo"/>
          {/* <img src={ singleJob?.user?.organisation_profile?.logo || logoBlanckImage} alt="Logo de l'entreprise" /> */}
        </div>
      </div> 

      <div className="w-full p-responsive gap-y-2 text-start space-y-2 mb-2">
        <h4 className=" text-2xl md:text-4xl font-bold">{singleJob?.offer?.job_title}</h4>
        <p className="text-lg md:text-xl">{singleJob?.offer?.user?.organisation_profile?.company_name}</p>
        <div className="flex gap-1 items-center text-primary-text">
          <p>{singleJob?.offer?.user?.organisation_profile?.address}</p>
        </div>
      </div>

      <div className="p-responsive flex justify-between   gap-10 mb-10">
        <div className=" w-full lg:w-2/3 leading-loose text-justify text-black space-y-6">
       <div>
          <h4 className="text-xl font-bold mb-2">
            A propos de l'entreprise
          </h4>
          <p className="text-primary-text">{singleJob?.offer?.user?.organisation_profile?.description}</p>
        </div>

        <div>
          <h4 className="text-xl font-bold mb-2">
            Description
          </h4>
          <p className='text-primary-text'>
            {singleJob?.offer?.description}
          </p>
        </div>
        {/* { singleJob?.offer?.required_skills?.length} */}
{singleJob?.offer?.required_skills?.length > 0 &&
  <div>
          <h4 className="text-xl font-bold mb-2">
            Compétences
          </h4>
          <div className="flex flex-wrap gap-4">
            {singleJob?.offer?.required_skills.map((item, index)=>{
              return (<div key={index} className="font-[490] px-6 py-2 bg-gray-100 text-primary-text rounded-lg">
              {item?.name}
            </div>)
            })}
            
          </div>
        </div>
}
        
        <div>
          <h4 className="text-xl font-bold mb-2">
            Missions et Responsabilités
          </h4>
          <p className='text-primary-text'>
           {singleJob?.offer?.mission}
           </p>
        </div>

        {/* Profil réquise */}
        <div>
          <h4 className="text-xl font-bold mb-2">
            Profil réquise
          </h4>
          <p className='text-primary-text'>
           {singleJob?.offer?.required_profile}
           </p>
        </div>
        {singleJob?.offer?.benefit &&
          <div>
          <h4 className="text-xl font-bold mb-2">
            Avantages
          </h4>
          <p className='text-primary-text'>
            {singleJob?.offer?.benefit}
          </p>
        </div>
        }
      
       </div>

       {/* Sticky Box */}
        <div className="w-1/3 h-[520px] bg-white border-2 border-gray-300 lg:block hidden rounded-2xl sticky top-20">
        <h5 className='text-xl font-semibold py-4 text-start px-6'>Information générale</h5>
       

<div className="border-b flex gap-4 items-center py-4 mx-6">
  <FaBriefcase className="text-2xl text-primary" />
  <div className="flex justify-between flex-col text-start">
    <div className='text-sm text-primary-text'>Type d'offre</div>
    <div className='font-semibold'>{singleJob?.offer?.contract_type}</div>
  </div>
</div>  

<div className="border-b flex gap-4 items-center py-4 mx-6">
  <FaClock className="text-xl text-primary" />
  <div className="flex justify-between flex-col text-start">
    <div className='text-sm text-primary-text'>Mode de travail</div>
    <div className='font-semibold'>{singleJob?.offer?.working_method}</div>
  </div>
</div>  

<div className="border-b flex gap-4 items-center py-4 mx-6">
  <FaMoneyBillWave className="text-2xl text-primary" />
  <div className="flex justify-between flex-col text-start">
    <div className='text-sm text-primary-text'>Salaire</div>
    <div className='font-semibold'>{formatSalary(singleJob?.offer?.salary)}</div>
  </div>
</div>

<div className="border-b flex gap-4 items-center py-4 mx-6">
  <FaCalendarAlt className="text-2xl text-primary" />
  <div className="flex justify-between flex-col text-start">
    <div className='text-sm text-primary-text'>Date de publication</div>
    <div className='font-semibold'>{formatDateTime(singleJob?.offer?.created_at)}</div>
  </div>
</div>

<div className="border-b flex gap-4 items-center py-4 mx-6">
  <FaRegCalendarTimes className="text-2xl text-primary" />
  <div className="flex justify-between flex-col text-start">
    <div className='text-sm text-primary-text'>Date d'expiration</div>
    <div className='font-semibold'>{formatDateTime(singleJob?.offer?.appli_end_at)}</div>
  </div>
</div>

         
          <div className="w-full px-4">
         <button onClick={()=>setShowModal(true)} className=' w-full rounded-md py-4 bg-primary-black text-white font-medium '>Postuler Maintenant</button>
         
          </div>
            </div>
      </div>

      <div className='w-full py-20 p-responsive bg-primary-beige'>
        <div className="flex justify-between items-center mb-10">
            <h4 className='text-4xl font-bold'>Offres similaires</h4>
            <button className="flex border-black rounded-sm items-center gap-2 px-4 py-2 border-2 border-primary-black  font-bold text-primary-black">Voir tout
            <svg className='w-6 rotate-180' viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#3C3D42" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"/><path fill="#3C3D42" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"/></svg>
            </button>
        </div>
        <div className='grid grid-col-span-1 gap-6'>
        {singleJob?.similar_offers?.map((item)=>{
          return( 
            <JobCard key={item.id} item={item} />
          )
      })}</div>
    </div>

    <FAQ></FAQ>

    <JobApplicationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmitSuccess={handleSuccess}
        user={user}
        offer={singleJob}
        setshowConfetti={()=>setshowConfetti(false)}
      />
{/* <Confetti show={showConfetti} /> */}
    </>
  )
}

export default JobDetail